// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"style_buttonWrapper__-Cs4N"};